module.exports = __webpack_public_path__ + "img/headImgMan.f9b99a29.png";